import Navigation from '../overview/components/navigation'
import User from '../overview/components/user'

const Tabs = () => {
  return (
    <div className='h-bg mb-8 w-full'>
      <User />
      <Navigation />
    </div>
  )
}

export default Tabs
